import { SearchTablesOutput } from "@zapier/bff";
import { trpc } from "../trpc";

type SearchTablesCache = SearchTablesOutput | undefined;

function removeTableFromSearchResults(
  cache: SearchTablesCache,
  id: string,
): SearchTablesCache {
  if (!cache) {
    return cache;
  }

  return {
    ...cache,
    data: cache.data.filter((table) => table.id !== id),
    meta: {
      ...cache.meta,
      count: cache.meta?.count ? cache.meta.count - 1 : 0,
    },
  };
}

interface Input {
  folderId?: string; // optional folderId for invalidating the folder assets query
}

export function useDeleteTable(input?: Input) {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  return trpc.table.delete.useMutation({
    onMutate: ({ id }) => {
      utils.table.search.cancel();
      // Remove table from the table search results cache
      utils.table.search.setData({}, (cache: SearchTablesCache) =>
        removeTableFromSearchResults(cache, id),
      );
    },
    onSettled: () => {
      utils.table.search.invalidate();
      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({
          folderId,
        });
      }
    },
  });
}
